import React from "react";
import { gettext } from "web/script/modules/django-i18n";

type PolicyTextProps = {
    privacyPolicyLink: string;
    termsAndConditionsLink?: string;
    className?: string;
};

export default function PolicyText({
    privacyPolicyLink,
    termsAndConditionsLink,
    className,
}: PolicyTextProps): JSX.Element {
    const privacyPolicyLinkProps = `href=${privacyPolicyLink} target="_blank"`;
    const termsAndConditionsLinkProps = `href=${termsAndConditionsLink} target="_blank"`;

    return (
        <div
            className={className}
            dangerouslySetInnerHTML={{
                // "By creating an account, you consent to Lyst’s Terms & Conditions.
                // To learn more about how Lyst uses and protects your personal data, please read Lyst’s Privacy Policy."
                __html: gettext("account.register.legal_agreement.sign_up_opt_in_terms", {
                    terms_and_conditions_link_props: termsAndConditionsLinkProps,
                    privacy_policy_link_props: privacyPolicyLinkProps,
                }),
            }}
        />
    );
}
